import * as Graph from '../graph';

const orgArgDescription = `A ${Graph.docType('org')}`;

export const opOrgMembers = Graph.makeOp({
  hidden: true,
  name: 'org-members',
  argTypes: {org: 'org'},
  description: `Returns the ${Graph.docType('user', {
    plural: true,
  })} belonging of an ${Graph.docType('org')}`,
  argDescriptions: {org: orgArgDescription},
  returnValueDescription: `The ${Graph.docType('user', {
    plural: true,
  })} belonging of the ${Graph.docType('org')}`,
  returnType: {type: 'list', objectType: 'user'},
  resolver: inputs => {
    const {org} = inputs;
    return org.members.map((e: any) => e.user);
  },
});

// FIXME(np): Not safe for large orgs
// ordering ops over runs table are way too expensive
// export const opOrgRuns = Graph.makeOp({
//   hidden: true,
//   name: 'org-runs',
//   argTypes: {org: 'org'},
//   returnType: {type: 'list', objectType: 'run'},
//   resolver: inputs => {
//     const {org} = inputs;
//     return org.runs.edges.map((e: any) => e.node);
//   },
// });

export const opOrgReports = Graph.makeOp({
  hidden: true,
  name: 'org-reports',
  argTypes: {org: 'org'},
  description: `Returns the ${Graph.docType('report', {
    plural: true,
  })} of an ${Graph.docType('org')}`,
  argDescriptions: {org: orgArgDescription},
  returnValueDescription: `The ${Graph.docType('report', {
    plural: true,
  })} of the ${Graph.docType('org')}`,
  returnType: {type: 'list', objectType: 'report'},
  resolver: inputs => {
    const {org} = inputs;
    return org.views.edges
      .filter((e: any) => e.node.type === 'runs')
      .map((e: any) => e.node);
  },
});

export const opOrgProjects = Graph.makeOp({
  hidden: true,
  name: 'org-projects',
  argTypes: {org: 'org'},
  description: `Returns the ${Graph.docType('project', {
    plural: true,
  })} of an ${Graph.docType('org')}`,
  argDescriptions: {org: orgArgDescription},
  returnValueDescription: `The ${Graph.docType('project', {
    plural: true,
  })} of the ${Graph.docType('org')}`,
  returnType: {type: 'list', objectType: 'project'},
  resolver: inputs => {
    const {org} = inputs;
    return org.projects.edges.map((e: any) => e.node);
  },
});

export const opOrgArtifacts = Graph.makeOp({
  hidden: true,
  name: 'org-artifacts',
  argTypes: {org: 'org'},
  description: `Returns the ${Graph.docType('artifact', {
    plural: true,
  })} of an ${Graph.docType('org')}`,
  argDescriptions: {org: orgArgDescription},
  returnValueDescription: `The ${Graph.docType('artifact', {
    plural: true,
  })} of the ${Graph.docType('org')}`,
  returnType: {type: 'list', objectType: 'artifact'},
  resolver: inputs => {
    const {org} = inputs;
    return org.artifactSequences.edges.map((e: any) => e.node);
  },
});
